// extracted by mini-css-extract-plugin
export default {"bet":"_3S_r4","betPrice":"_12Qth"};